<template>
  <div>
    <el-form-item label="选择分组">
      <el-select v-model="value" style="width: 150px" multiple placeholder="请选择">
        <el-option
          v-for="item in groups"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
    </el-form-item>
  </div>
</template>

<script>
import { getUserTypeAllList } from '@/api/config/user-group-cfg'

export default {
  name: 'GetGroup',
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      groups: [{ label: '默认分组', value: 0 }]
    }
  },
  watch: {
    value(val) {
      this.$emit('input', val)
    }
  },
  created() {
    this.getGroup()
  },
  methods: {
    getGroup() {
      getUserTypeAllList().then(res => {
        if (res.code === 200) {
          res.data.forEach(res => {
            this.groups.push({ label: res.name, value: res.groupId })
          })
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
